import { Alert, Box, Button } from '@mui/material';

interface IProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const GlobalFallback = ({ resetErrorBoundary }: IProps) => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      <div className='flex flex-col gap-4 items-end'>
        <Alert sx={{ width: '50vw' }} severity='error'>
          Something went wrong
        </Alert>
        <Button variant='contained' onClick={resetErrorBoundary}>
          Refresh
        </Button>
      </div>
    </Box>
  );
};

export default GlobalFallback;
